import { db } from "../firebase.config";
import { 
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  arrayUnion,
  arrayRemove
} from "firebase/firestore";

export const FolderService = {
  async createFolder(userId, name) {
    try {
      const folderRef = await addDoc(collection(db, "folders"), {
        userId,
        name,
        threads: [],
        createdAt: new Date()
      });
      return {
        id: folderRef.id,
        name,
        threads: [],
        createdAt: new Date()
      };
    } catch (error) {
      console.error("Error creating folder:", error);
      throw error;
    }
  },

  async getUserFolders(userId) {
    try {
      const q = query(
        collection(db, "folders"),
        where("userId", "==", userId)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error("Error getting folders:", error);
      throw error;
    }
  },

  async addThreadToFolder(folderId, threadId) {
    try {
      const folderRef = doc(db, "folders", folderId);
      await updateDoc(folderRef, {
        threads: arrayUnion(threadId)
      });
    } catch (error) {
      console.error("Error adding thread to folder:", error);
      throw error;
    }
  },

  async removeThreadFromFolder(folderId, threadId) {
    try {
      const folderRef = doc(db, "folders", folderId);
      await updateDoc(folderRef, {
        threads: arrayRemove(threadId)
      });
    } catch (error) {
      console.error("Error removing thread from folder:", error);
      throw error;
    }
  },

  async deleteFolder(folderId) {
    try {
      await deleteDoc(doc(db, "folders", folderId));
    } catch (error) {
      console.error("Error deleting folder:", error);
      throw error;
    }
  }
}; 